var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.httpRoute),function(item,index){return _c('div',{key:index,staticClass:"mb-1"},[_vm._l((item.method),function(i){return _c('el-tag',{key:i,staticClass:"mr-1"},[_vm._v("\n      "+_vm._s(i)+"\n    ")])}),_c('code',[_vm._v(_vm._s('/admin-api' + item.path))])],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }